import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import AuthService from '../services/auth.service';
import { decodeIdToken, decodeMetadataToken } from '../utils/token.utils';

const SSOCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const handleSsoCallback = async () => {
            try {
                const code = searchParams.get('code');
                const state = searchParams.get('state');
                
                if (!code) {
                    throw new Error('No authorization code received');
                }

                // Parse state to get planId and register flag if they exist
                let planId = 'All-In-One-USD-Monthly-100';
                let isRegistration = false;
                if (state) {
                    try {
                        const stateData = JSON.parse(state);
                        if (stateData.planId) {
                            planId = stateData.planId;
                        }
                        isRegistration = stateData.isRegistration || false;
                    } catch (e) {
                        console.error('Error parsing state:', e);
                    }
                }

                // Exchange code for user info
                const response = await AuthService.getTokensFromCode(code, isRegistration, isRegistration && !planId);

                if(response.data.linkAccounts) {
                    navigate('/link-account');
                    return;
                }

                const idToken = decodeIdToken();
                const metadataToken = decodeMetadataToken();
                
                //User have a preferred_username when they login with SSO
                if(idToken?.preferred_username) {

                    //User have a preferred_username when they login with SSO and no subscription then we need to redirect to SSO signup page
                    if(metadataToken.companies[0].subscription == null) {
                        const params = new URLSearchParams({
                            planId: 'All-In-One-USD-Monthly-100'
                        });
                        // Redirect to SSO signup page when subscription is null
                        navigate(`/sso-signup?${params.toString()}`);
                        return;
                    }

                    //User have a preferred_username when they login with SSO and subscription then we need to redirect to dashboard
                    console.log('No preferred_username, redirecting to dashboard');
                    navigate('/dashboard?redirect=easywebinar');
                    return;
                }

                //Otherwise, user is new and we need to redirect to SSO signup page
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('code');
                window.history.replaceState({}, '', newUrl);

                // Construct redirect URL with parameters
                const params = new URLSearchParams({
                    ...(planId && { planId })
                });

                // Redirect to SSO signup page with user info
                navigate(`/sso-signup?${params.toString()}`);
            } catch (error) {
                console.error('SSO callback error:', error);
                navigate('/signup');
            }
        };

        handleSsoCallback();
    }, [navigate, searchParams]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <CircularProgress />
        </Box>
    );
};

export default SSOCallback;